import React, { useState, useEffect } from "react";
import environment from "../../../../utils/environment";
import "./EditNurse.css";
import Widgets from "../../../../widgets";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProgressBarDynamic from "../../../../widgets/ProgressBarforMangeNurse/ProgressBarDynamic";
import { faPlus, faTrash, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import SelectCard from "../../../../widgets/selectCard/selectCard";
import Icons from "../../../../Assets/Icons";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { resetGetNurseDetails, resetEditNurse } from "../../../../modules/NursignCare/ManageNurse/ManageNurseSlice";
import { getNurseDetails, getAllServices, getSubServices, getServiceItems, editNurse, deleteNurse, toggleNurseActiveStatus } from "../../../../modules/NursignCare/ManageNurse/ManageNurseThunk";
import MultiSelector from "../../../../widgets/SelectDropdown/MultiSelector";
import useValidation from "../../../../utils/validators";
import ToastPopup from "../../../../widgets/Toast/toastPopup";
import strings from "../../../../utils/strings";
import { getLocalizedText } from "../../../../utils/localization";
import { uploadMedia } from "../../../../modules/patientProfile/patientProfileThunk";

const EditNurse = () => {
  const { nurseId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const breadcrumbs = [t("nursing_care"), t("manage_nurse"), t("Nurse")];
  const paths = [strings.navigation.nurseList, strings.navigation.nurseList, strings.navigation.editNurse];
  const [isOn, setIsOn] = useState(false);
  const [selectedServiceGroups, setSelectedServiceGroups] = useState([]);
  const [subServiceGroupOptions, setSubServiceGroupOptions] = useState([]);
  const [selectedSubServiceGroups, setSelectedSubServiceGroups] = useState([]);
  const [serviceItemsOptions, setServiceItemsOptions] = useState([]);
  const [serviceGroupOptions, setServiceGroupOptions] = useState([]);
  const [selectedServiceItems, setSelectedServiceItems] = useState([]);
  const { validateEditNurse } = useValidation();
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [showActivateModal, setShowActivateModal] = useState(false);
  const countries = [
    { code: "+1", alpha2code: "US" },
    { code: "+91", alpha2code: "IN" },
    { code: "+84", alpha2code: "VN" },
  ];
  const sufix = [{ title: t("mr") }, { title: t("mrs") }, { title: t("miss") }];
  const [selectedTitle, setSelectedTitle] = useState(t("mr"));
  const [showTitle, setShowTitle] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("+91");
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [isPhotoUploaded, setIsPhotoUploaded] = useState(false);
  const [isPhotoUploading, setIsPhotoUploading] = useState(false);
  const [selectedLang, setSelectedLang] = useState({ value: "EN", label: t("English") });
  const langOptions = [
    { value: "VI", label: t("vietnamese") },
    { value: "EN", label: t("english") },
  ];
  const [showStatusModal, setShowStatusModal] = useState(false);
  // const [inactiveRange, setInactiveRange] = useState({ startDate: "", endDate: "" });
  const { getNurseDetailsSuccess, getNurseDetailsErr, editNurseSuccess, editNurseErr, services = [] } = useSelector((state) => state.manageNurse || {});

  // Toggle only updates UI state; API calls are deferred to Save
  const toggleSwitch = () => {
    if (isOn) {
      // setShowStatusModal(true); // preserved as comment
      setShowDeactivateModal(true);
    } else {
      setShowActivateModal(true);
      /* dispatch(toggleNurseActiveStatus({ nurseId }))
        .unwrap()
        .then(() => {
          setIsOn(true);
          ToastPopup.success(t("nurseActivatedSuccessfully"));
        })
        .catch(() => {
          ToastPopup.error(t("errorActivatingNurse"));
        }); */
    }
  };
  const extractString = (val) => {
    if (val && typeof val === "object" && !Array.isArray(val)) {
      return val[i18n.language] || val.en || val.vi || "";
    }
    return val || "";
  };
  const handlePhotoUpload = async ({ files }) => {
    if (files.length > 0) {
      const file = files[0];
      const imageURL = URL.createObjectURL(file);
      setUploadedImage(imageURL);
      setIsPhotoUploading(true);

      try {
        const uploadResponse = await dispatch(uploadMedia({ files: [file] })).unwrap();
        const profilePhoto = uploadResponse?.data?.urls?.[0] || "";

        setFormData((prevData) => ({
          ...prevData,
          profilePhoto,
        }));
        setIsPhotoUploaded(Boolean(profilePhoto));
      } catch (error) {
        setUploadedImage(null);
        setIsPhotoUploaded(false);
        ToastPopup.error(error?.message || error || t("selectValidImage"));
      } finally {
        setIsPhotoUploading(false);
      }
    }
  };

  const handleCountryChange = (code) => {
    setSelectedCountry(code);
    setShowDropdown(false);
    setFormData((prevData) => ({
      ...prevData,
      countryCode: code,
    }));
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
  };

  const handleConfirmDelete = () => {
    // Delete button disabled – deletion handled via toggle + save
    setShowDeleteModal(false);
  };

  const handleTitleChange = (title) => {
    setSelectedTitle(title);
    setShowTitle(false);
  };
  const handleCancelStatus = () => {
    setShowStatusModal(false);
  };

  /*const handleConfirmStatus = async ({ startDate, endDate }) => {
    setShowStatusModal(false);
    dispatch(resetEditNurse());
    try {
      await dispatch(toggleNurseActiveStatus({ nurseId, startDate, endDate })).unwrap();
      setIsOn(false);
      setInactiveRange({ startDate, endDate });
      ToastPopup.success(t("nurseDeactivatedSuccessfully"));
      navigate(strings.navigation.nurseList);
    } catch (error) {
      console.error("Error deactivating nurse:", error);
      ToastPopup.error(t("nurseNotDeleted"));
    }
  };*/

  const handleConfirmDeactivate = async () => {
    setShowDeactivateModal(false);
    try {
      await dispatch(toggleNurseActiveStatus({ nurseId })).unwrap();
      setIsOn(false);
      ToastPopup.success(t("nurseDeactivatedSuccessfully"));
    } catch (error) {
      console.error("Error deactivating nurse:", error);
      ToastPopup.error(t("nurseNotDeactivated"));
    }
  };
  const handleConfirmActivate = async () => {
    setShowActivateModal(false);

    try {
      await dispatch(
        toggleNurseActiveStatus({
          nurseId,
        }),
      ).unwrap();

      ToastPopup.success(t("nurseActivatedSuccessfully"));
      setIsOn(true);
    } catch (error) {
      ToastPopup.error(t("nurseNotActivated"));
    }
  };

  const [serviceGroups, setServiceGroups] = useState([{ id: 1, serviceGroup: "", subServiceGroup: "", serviceItems: "" }]);

  const [formData, setFormData] = useState({
    firstName: { en: "", vi: "" },
    lastName: { en: "", vi: "" },
    email: "",
    employeeId: "",
    phoneNumber: "",
    dateOfBirth: "",
    gender: "",
    languages: [],
    designation: { en: "", vi: "" },
    address: { en: "", vi: "" },
    countryCode: "+91",
    serviceGroups: serviceGroups,
    specialization: [],
    profilePhoto: "",
  });

  useEffect(() => {
    // Fetch all services when the component mounts — show only active ones
    dispatch(getAllServices())
      .unwrap()
      .then((response) => {
        const serviceOptions = (response.data.services || [])
          .filter((service) => service.isActive !== false)
          .map((service) => ({
            value: service._id,
            label: getLocalizedText(service.title, i18n.language),
          }));
        setServiceGroupOptions(serviceOptions);
      })
      .catch((error) => {
        console.error("Error fetching services:", error);
      });
  }, [dispatch]);

  useEffect(() => {
    dispatch(getNurseDetails(nurseId));
    return () => {
      dispatch(resetGetNurseDetails());
    };
  }, [nurseId, dispatch]);

  useEffect(() => {
    if (getNurseDetailsSuccess) {
      const nurse = getNurseDetailsSuccess.data.nurse;
      setFormData({
        nurseId: nurse._id,
        firstName: {
          en: nurse.firstName?.en || extractString(nurse.firstName) || "",
          vi: nurse.firstName?.vi || extractString(nurse.firstName) || "",
        },
        lastName: {
          en: nurse.lastName?.en || extractString(nurse.lastName) || "",
          vi: nurse.lastName?.vi || extractString(nurse.lastName) || "",
        },
        email: extractString(nurse.email),
        phoneNumber: extractString(nurse.phoneNumber),
        employeeId: extractString(nurse.employeeID),
        dateOfBirth: nurse.dateOfBirth,
        gender: getLocalizedText(nurse.gender, i18n.language),
        languages: nurse.languages || [],
        designation: {
          en: nurse.designation?.en || extractString(nurse.designation) || "",
          vi: nurse.designation?.vi || extractString(nurse.designation) || "",
        },
        address: {
          en: nurse.address?.en || extractString(nurse.address) || "",
          vi: nurse.address?.vi || extractString(nurse.address) || "",
        },
        countryCode: nurse.countryCode || "+91",
        specialization: nurse.specialization || [],
        profilePhoto: nurse.profilePhoto || "",
      });
      setIsOn(nurse.isActive); // Set active status
      setSelectedCountry(nurse.countryCode || "+91");
      setSelectedTitle(nurse.title || "Mr.");
      // Set service groups if available
      const serviceGroups = [];
      const subServiceGroups = [];
      const serviceItems = [];

      // Loop through each specialization to populate the selected options
      nurse.specialization.forEach((spec) => {
        serviceGroups.push({
          value: spec.service._id,
          label: getLocalizedText(spec.service.title, i18n.language),
        });

        subServiceGroups.push({
          value: spec.subService._id,
          label: getLocalizedText(spec.subService.title, i18n.language),
        });

        serviceItems.push({
          value: spec._id,
          label: getLocalizedText(spec.title, i18n.language),
        });
      });

      // Set the selected options in state
      setSelectedServiceGroups(serviceGroups);
      setSelectedSubServiceGroups(subServiceGroups);
      setSelectedServiceItems(serviceItems);
    }
  }, [getNurseDetailsSuccess]);

  // const formattedDate = new Date(formData.dateOfBirth).toISOString().split('T')[0]; // Converts to YYYY-MM-DD

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    const currentLang = selectedLang.value.toLowerCase(); // 'en' or 'vi'

    if (name === "dateOfBirth") {
      newValue = new Date(value).toISOString();
    }

    if (name === "firstName" || name === "lastName" || name === "address" || name === "designation") {
      newValue = newValue.startsWith(" ") ? newValue.trimStart() : newValue;
      if (name !== "address" && name !== "designation") {
        newValue = newValue.replace(/[^a-zA-Z\s]/g, "");
      }

      setFormData((prevData) => ({
        ...prevData,
        [name]: {
          ...prevData[name],
          [currentLang]: newValue,
        },
      }));
      return;
    }
    if (name === "employeeId") {
      newValue = newValue.toUpperCase();
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const { firstName, lastName, email, employeeId, phoneNumber, dateOfBirth, gender, languages, designation, address } = formData;

    const filledFields = [
      formData.firstName.en.trim() !== "" && formData.firstName.vi.trim() !== "",
      formData.lastName.en.trim() !== "" && formData.lastName.vi.trim() !== "",
      formData.email.trim() !== "",
      formData.employeeId.trim() !== "",
      formData.phoneNumber.trim() !== "",
      formData.dateOfBirth.trim() !== "",
      formData.gender.trim() !== "",
      formData.languages.length > 0,
      formData.designation.en.trim() !== "" && formData.designation.vi.trim() !== "",
      formData.address.en.trim() !== "" && formData.address.vi.trim() !== "",
      isPhotoUploaded,
      selectedServiceGroups.length > 0,
      selectedSubServiceGroups.length > 0,
      selectedServiceItems.length > 0,
    ].filter(Boolean).length;

    const totalFields = 15;
    const progressPercentage = (filledFields / totalFields) * 100;

    setProgress(parseFloat(progressPercentage.toFixed(2)));
  }, [formData, selectedServiceGroups, selectedSubServiceGroups, selectedServiceItems, isPhotoUploaded]);

  const handleLanguageChange = (selectedOptions) => {
    // Update the languages field with selected values
    setFormData((prevData) => ({
      ...prevData,
      languages: selectedOptions ? selectedOptions.map((option) => option.value) : [],
    }));
  };

  const options = [
    { value: "English", label: t("english") },
    { value: "Vietnamese", label: t("vietnamese") },
  ];

  useEffect(() => {
    dispatch(getAllServices());
    dispatch(getNurseDetails(nurseId));
    return () => {
      dispatch(resetGetNurseDetails());
    };
  }, [nurseId, dispatch]);

  const handleServiceGroupChange = (selectedOptions) => {
    setSelectedServiceGroups(selectedOptions);

    // Fetch sub-services for selected service groups
    const serviceIds = selectedOptions.map((option) => option.value);
    Promise.all(serviceIds.map((serviceId) => dispatch(getSubServices(serviceId)).unwrap()))
      .then((responses) => {
        const allSubServices = responses.flatMap((response) =>
          (response.data.subServices || [])
            .filter((subService) => subService.isActive !== false)
            .map((subService) => ({
              value: subService._id,
              label: getLocalizedText(subService.title, i18n.language),
            })),
        );
        // Remove duplicates
        const uniqueSubServices = Array.from(new Set(allSubServices.map((s) => s.value))).map((value) => allSubServices.find((s) => s.value === value));
        setSubServiceGroupOptions(uniqueSubServices);
      })
      .catch((error) => {
        console.error("Error fetching sub-services:", error);
      });
  };

  const handleSubServiceGroupChange = (selectedOptions) => {
    setSelectedSubServiceGroups(selectedOptions);

    // Fetch service items for selected sub-service groups
    const subServiceIds = selectedOptions.map((option) => option.value);
    const serviceIds = selectedServiceGroups.map((option) => option.value);

    Promise.all(serviceIds.flatMap((serviceId) => subServiceIds.map((subServiceId) => dispatch(getServiceItems({ serviceId, subServiceId })).unwrap())))
      .then((responses) => {
        const allServiceItems = responses.flatMap((response) =>
          (response.data.serviceItems || [])
            .filter((item) => item.isActive !== false)
            .map((item) => ({
              value: item._id,
              label: getLocalizedText(item.title, i18n.language),
            })),
        );
        // Remove duplicates
        const uniqueServiceItems = Array.from(new Set(allServiceItems.map((i) => i.value))).map((value) => allServiceItems.find((i) => i.value === value));
        setServiceItemsOptions(uniqueServiceItems);
      })
      .catch((error) => {
        console.error("Error fetching service items:", error);
      });
  };
  const handleSave = async () => {
    const isValid = validateEditNurse(formData, {
      selectedServiceGroups,
      selectedSubServiceGroups,
      selectedServiceItems,
    });

    if (!isValid) return;
    if (isPhotoUploading) {
      ToastPopup.error("Please wait for the image upload to finish.");
      return;
    }

    const editableData = { ...formData };
    delete editableData.nurseId;
    delete editableData.employeeId;
    delete editableData.serviceGroups;

    const nursePayload = {
      ...editableData,
      employeeID: formData.employeeId,
      isActive: isOn,
      specialization: selectedServiceItems.map((item) => item.value),
      profilePhoto: formData.profilePhoto,
    };

    dispatch(resetEditNurse());

    try {
      await dispatch(editNurse({ nurseId, nurseData: nursePayload })).unwrap();
      ToastPopup.success(t("nurseUpdatedSuccessfully"));
      navigate(strings.navigation.nurseList);
    } catch (error) {
      console.error("Error updating nurse:", error);
      ToastPopup.error(t("nurseNotUpdated"));
    }
  };

  return (
    <div className="edit-nurse-container">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />

      <div className="dp-heading-flex">
<div className="manage-service-heading department-heading">
    {formData.firstName?.en && formData.lastName?.en 
      ? `${formData.firstName.en} ${formData.lastName.en}`
      : nurseId} 
  </div>        <Widgets.NewSelectDropdown options={langOptions} big placeholder={t("selGrpName")} onChange={(i) => setSelectedLang(i)} selectedValue={selectedLang} />
      </div>

      <div className="edit-nurse-grid-container">
        <div className="edit-grid-item">
          <div className="edit-grid-item-1">
            <div className="edit-nurse-heading">{t("generalInfo")}</div>
            <div className="edit-nurse-heading-active">
              <p className="edit-nurse-heading-active-p">{isOn ? t("active") : t("inactive")}</p>
              <div className="toggle-container">
                <div className={`toggle-switch ${isOn ? "on" : "off"}`} onClick={toggleSwitch}>
                  <div className="toggle-knob"></div>
                </div>
              </div>
            </div>
          </div>
          <hr className="edit-nurse-hr" />

          <div className="edit-nurse-general-information">
            <div className="edit-nurse-general-information-1">
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">
                  {t("firstName")}
                  <span className="edit-star">*</span>
                </div>
                <div className="edit-nurse-general-information-1-input">
                  <div className="phone-input">
                    <div className="country-code-dropdown sufix-code" onClick={() => setShowTitle(!showTitle)}>
                      {t(selectedTitle)}
                      <FontAwesomeIcon icon={faChevronDown} />
                      <div className="vertical-line"></div>
                    </div>
                    {showTitle && (
                      <div className="dropdown-modal sufix-modal">
                        {sufix.map((titles) => (
                          <div key={titles.title} onClick={() => handleTitleChange(titles.title)} className="dropdown-item">
                            {t(titles.title)}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <input
                    type="text"
                    name="firstName"
                    placeholder={t("namePlaceholder") + ` (${selectedLang.value})`}
                    autoComplete="off"
                    className="edit-input-field-name"
                    value={formData.firstName[selectedLang.value.toLowerCase()]}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">
                  {t("lastName")}
                  <span className="edit-star">*</span>
                </div>
                <div className="edit-nurse-general-information-1-input">
                  <input
                    type="text"
                    name="lastName"
                    placeholder={t("lastnamePlaceholder") + ` (${selectedLang.value})`}
                    className="edit-input-field"
                    autoComplete="off"
                    value={formData.lastName[selectedLang.value.toLowerCase()]}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            <div className="edit-nurse-general-information-1">
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">
                  {t("emailId")}
                  <span className="edit-star">*</span>
                </div>
                <div className="edit-nurse-general-information-1-input">
                  <input type="text" name="email" placeholder={t("emailPlaceholder")} autoComplete="off" className="edit-input-field" value={formData.email} onChange={handleChange} />
                </div>
              </div>
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">
                  {t("dob")}
                  <span className="edit-star">*</span>
                </div>
                <div className="edit-nurse-general-information-1-input">
                  <input
                    type="date"
                    name="dateOfBirth"
                    className="edit-input-field"
                    value={formData.dateOfBirth ? new Date(formData.dateOfBirth).toISOString().split("T")[0] : ""}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            <div className="edit-nurse-general-information-1">
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">
                  {t("employeeId")}
                  <span className="edit-star">*</span>
                </div>
                <div className="edit-nurse-general-information-1-input">
                  <input type="text" name="employeeId" autoComplete="off" placeholder={t("nationalIdPlaceholder")} className="edit-input-field" value={formData.employeeId} onChange={handleChange} />
                </div>
              </div>
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">
                  {t("phoneNumber")}
                  <span className="edit-star">*</span>
                </div>
                <div className="edit-nurse-general-information-1-input">
                  <div className="phone-input">
                    <div className="country-code-dropdown" onClick={() => setShowDropdown(!showDropdown)}>
                      {selectedCountry}
                      <FontAwesomeIcon icon={faChevronDown} />
                      <div className="vertical-line"></div>
                    </div>
                    {showDropdown && (
                      <div className="dropdown-modal">
                        {countries.map((country) => (
                          <div key={country.code} onClick={() => handleCountryChange(country.code)} className="dropdown-item">
                            ({country.code})
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <input
                    type="text"
                    id="phoneNumber"
                    name="phoneNumber"
                    autoComplete="off"
                    placeholder={t("phonePlaceholder")}
                    className="edit-input-field-name"
                    required
                    value={formData.phoneNumber}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="edit-nurse-general-information-1">
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">
                  {t("gender")}
                  {/* <span className="edit-star">*</span> */}
                </div>
                <div className="edit-nurse-general-information-1-input-gender">
                  <div className="input-gender-section">
                    <input
                      type="radio"
                      id="male"
                      name="gender"
                      value="Male"
                      checked={formData.gender === "Male"}
                      onChange={(e) =>
                        setFormData((prevData) => ({
                          ...prevData,
                          gender: e.target.value,
                        }))
                      }
                      required
                    />
                    <label htmlFor="male">{t("male")}</label>
                  </div>
                  <div className="input-gender-section">
                    <input
                      type="radio"
                      id="female"
                      name="gender"
                      value="Female"
                      checked={formData.gender === "Female"}
                      onChange={(e) =>
                        setFormData((prevData) => ({
                          ...prevData,
                          gender: e.target.value,
                        }))
                      }
                      required
                    />
                    <label htmlFor="female">{t("female")}</label>
                  </div>
                </div>
              </div>
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">
                  {t("designation")}
                  <span className="edit-star">*</span>
                </div>
                <div className="edit-nurse-general-information-1-input">
                  <input
                    type="text"
                    id="designation"
                    name="designation"
                    required
                    autoComplete="off"
                    placeholder={`${t("jobTitle")} (${selectedLang.value})`}
                    className="edit-input-field"
                    value={formData.designation[selectedLang.value.toLowerCase()]}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            <div className="edit-nurse-general-information-1">
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">
                  {t("language")}
                  <span className="edit-star">*</span>
                </div>
                <div className="edit-nurse-general-information-1-input">
                  <Select
                    id="languages"
                    name="languages"
                    placeholder={t("selectLang")}
                    required
                    isMulti
                    options={options}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={options.filter((option) => Array.isArray(formData.languages) && formData.languages.includes(option.value))}
                    onChange={handleLanguageChange}
                  />
                </div>
              </div>
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">
                  {t("address")}
                  <span className="edit-star">*</span>
                </div>
                <div className="edit-nurse-general-information-1-input">
                  <input
                    type="text"
                    name="address"
                    placeholder={t("addressPlaceholder") + ` (${selectedLang.value})`}
                    autoComplete="off"
                    className="edit-input-field"
                    value={formData.address[selectedLang.value.toLowerCase()]}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="edit-nurse-grid-item">
          <div className="edit-grid-item-2">
            <div className="edit-nurse-progress">{t("inProgress")}</div>
            <ProgressBarDynamic value={progress} />
          </div>
          <div className="edit-grid-item-2">
            <div className="edit-nurse-heading ">{t("photo")}</div>
            <hr className="edit-nurse-photo-hr" />
            <div className="edit-nurse-photo-upload">
              <div className="edit-nurse-photo-container">
                <img
                  src={
                    uploadedImage || (formData.profilePhoto ? (formData.profilePhoto.startsWith("http") ? formData.profilePhoto : `${environment.apiURL}${formData.profilePhoto}`) : Icons.profileNurse)
                  }
                  alt="Profile"
                />
              </div>
              <div className="select-card-container">
                <SelectCard onImageUpload={handlePhotoUpload} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="edit-grid-item-3">
        <div className="">
          <h2 className="edit-nurse-heading">{t("specialization")}</h2>
          <hr className="edit-nurse-hr" />
          {serviceGroups.map((group, index) => (
            <div key={group.id} className="specialization-section">
              <div className="specialization-section-first">
                <label className="edit-nurse-general-information-1-heading">
                  {t("serviceGroup")}
                  <span className="edit-star">*</span>
                </label>
                <div className="specialization-section-input">
                  <MultiSelector options={serviceGroupOptions} selectedOptions={selectedServiceGroups} setSelectedOptions={handleServiceGroupChange} />
                </div>
              </div>

              <hr className="edit-nurse-hr" />
              <div className="specialization-section-first">
                <label className="edit-nurse-general-information-1-heading">
                  {t("subServiceGroup")}
                  <span className="edit-star">*</span>
                </label>
                <div className="specialization-section-input">
                  <MultiSelector options={subServiceGroupOptions} selectedOptions={selectedSubServiceGroups} setSelectedOptions={handleSubServiceGroupChange} />
                </div>
              </div>
              <hr className="edit-nurse-hr" />
              <div className="specialization-section-first">
                <label className="edit-nurse-general-information-1-heading">
                  {t("serviceItem")}
                  <span className="edit-star">*</span>
                </label>
                <div className="specialization-section-input">
                  <MultiSelector options={serviceItemsOptions} selectedOptions={selectedServiceItems} setSelectedOptions={setSelectedServiceItems} />
                </div>
              </div>
            </div>
          ))}
          {/* Add Button */}
        </div>
      </div>

      <div className="edit-section-footer-buttons">
        <div className="edit-section-footer-buttons-1">
          <button onClick={() => navigate(strings.navigation.nurseList)}>{t("cancel")}</button>
        </div>
        <div className="edit-section-footer-buttons-2">
          <button onClick={handleSave}>
            {t("save")}
          </button>
        </div>
      </div>
      <Widgets.ConfirmModal
        showModal={showActivateModal}
        handleCancel={() => setShowActivateModal(false)}
        handleConfirm={handleConfirmActivate}
        heading="activateNurseHead"
        description="activateNurseDesc"
      />

      <Widgets.ConfirmModal
        showModal={showDeactivateModal}
        handleCancel={() => setShowDeactivateModal(false)}
        handleConfirm={handleConfirmDeactivate}
        heading="deactivateNurseHead"
        description="deactivateNurseDesc"
      />

      {/* <Widgets.StatusChangeModal showModal={showStatusModal} onCancel={handleCancelStatus} onConfirm={handleConfirmStatus} /> */}
      {/* <Widgets.StatusChangeModal showModal={showStatusModal} onCancel={handleCancelStatus} onConfirm={handleConfirmStatus} /> */}
    </div>
  );
};

export default EditNurse;
